import * as _ from "lodash";
import { Components } from "formiojs";
import { ValidationPatterns } from "@bbwt/modules/validation";

const TextFieldComponent = Components.components.textfield;

export default class MiproClinicianEmailField  extends TextFieldComponent  {

    static schema() {
        return TextFieldComponent.schema({
            type: "miproClinicianEmailField",
            label: "Clinician Email",
            key: "dbo.mipro.miproClinicianEmail",
            placeholder: "Enter Clinician Email", 
            disabled: false, 
            input: true,
            validate: {
                custom: `valid = (!input || !!input.match(/${ValidationPatterns.email}/)) ? true : "Invalid email address";`
            }
        });
    }

    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Clinician Email",
            group: "basic",
            icon: "envelope",
            weight: 70,
            schema: MiproClinicianEmailField.schema(),            
        };
    }
}

Components.addComponent("miproClinicianEmailField", MiproClinicianEmailField);